import Image from 'next/image';
import React from 'react';

const ContactCTA = () => {
  return (
    <div className="w-full py-16 md:py-[84px] relative">
      <Image
        src={
          'https://images.unsplash.com/photo-1603966926902-57b0cb2abe2a?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
        }
        alt="Nền liên hệ nhận báo giá - Trường Thọ Food"
        fill
        style={{ objectFit: 'cover', position: 'absolute' }}
      />
      <div className="absolute inset-0 bg-black opacity-50 z-0"></div>
      <div className="container flex flex-col gap-4 items-center relative z-10">
        <p className="uppercase text-[24px] md:text-[32px] font-bold text-white">
          Liên hệ để nhận báo giá
        </p>
        <p className="font-semibold text-[16px] md:text-[24px] text-white text-center max-w-3xl">
          Bạn đang tìm kiếm đơn vị cung cấp trứng gà tươi ngon, chất lượng với giá cả hợp lý? Hãy liên hệ với chúng tôi ngay hôm nay!
        </p>
        <div className="flex gap-4 flex-wrap justify-center">
          <button className="bg-primary h-fit whitespace-nowrap text-white duration-300 w-fit text-[18px] pt-2 pb-1 px-8 rounded-full hover:text-white hover:bg-transparent relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-white">
            Hotline
          </button>
          <button className="bg-primary h-fit whitespace-nowrap text-white duration-300 w-fit text-[18px] pt-2 pb-1 px-8 rounded-full hover:text-white hover:bg-transparent relative after:absolute after:inset-0 after:rounded-full after:w-full after:h-full hover:after:border-[1px] hover:after:border-white">
            Zalo
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactCTA;
